// extracted by mini-css-extract-plugin
export default {"cls1":"GmpPkV2s0yTdeSOsPJQn","cls2":"FAGUDpm0hExRskiL5C2U GmpPkV2s0yTdeSOsPJQn"};